import React from "react";
import { NavLink, withRouter } from "react-router-dom";

const ListGroup = ({
  items,
  textProperty,
  valueProperty,
  linkProperty,
  iconProperty,
  selectedItem,
  onItemSelect,
  location,
  history
}) => {
  return (
    <ul className="list-group list-group-flush">
      {items.map(item => (
        <NavLink 
          to={item[linkProperty]}
          onClick={(e) => {
            const targetPath = item[linkProperty];
            if (location?.pathname === targetPath && history?.replace) {
              e.preventDefault();
              history.replace({
                pathname: targetPath,
                state: {
                  ...(location?.state || {}),
                  refreshToken: Date.now()
                }
              });
            }
            if (onItemSelect) onItemSelect(item);
          }}
          key={item[valueProperty]}
          className={"list-group-item text-decoration-none"}
          activeClassName="active"
        >
          <span className="m-2">{item[iconProperty]}</span> 
          {item[textProperty]}
          <span className="pull-right d-none d-lg-block"><i className="fa fa-angle-right" /></span> 
        </NavLink>
      ))}
    </ul>
  );
};

ListGroup.defaultProps = {
  textProperty: "name",
  valueProperty: "id",
  linkProperty: "to",
  iconProperty: "icon"
};

export default withRouter(ListGroup);
